import { configureStore } from '@reduxjs/toolkit';

// Onchain redux slices removed - contract, overview, wallet slices removed
// Redux store simplified - placeholder reducer required so combineReducers receives valid reducers

function _placeholder(state = null) {
  return state;
}

export const store = configureStore({
  reducer: { _placeholder },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Redux persist removed - no slices to persist
